export default "/_next/static/images/service-drop-ins-desktop-2x-d59c347394e6bb370910ee48afbcdb4e.jpg";